import type { Dictionary } from '../types.js';

/** Russian (Русский) dictionary. Must match the English key structure. */
export const ru: Dictionary = {
  common: {
    appName: 'Astral Studio',
    save: 'Сохранить',
    saving: 'Сохранение…',
    saved: 'Сохранено',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Изменить',
    create: 'Создать',
    duplicate: 'Дублировать',
    search: 'Поиск',
    loading: 'Загрузка…',
    back: 'Назад',
    confirm: 'Подтвердить',
    close: 'Закрыть',
    retry: 'Повторить',
    comingSoon: 'Скоро',
    optional: 'необязательно',
    add: 'Добавить',
    remove: 'Убрать',
    done: 'Готово',
    archive: 'В архив',
    restore: 'Восстановить',
    copied: 'Скопировано',
  },
  language: {
    title: 'Выберите язык',
    subtitle: 'Позже это можно изменить в настройках.',
    continue: 'Продолжить',
  },
  onboarding: {
    welcomeSubtitle: 'Sticker Studio',
    enterSub: 'Создавайте стикерпаки для Telegram',
    touchStatue: 'Коснитесь статуи, чтобы войти',
    channelPrompt: 'Вступите, чтобы пользоваться Sticker Studio',
    chooseLook: 'Настройте свою студию',
    colorTheme: 'Цветовая тема',
    resetTheme: 'Сбросить на тему Astral',
    appearance: 'Оформление',
  },
  nav: {
    home: 'Главная',
    projects: 'Проекты',
    channels: 'Каналы',
    settings: 'Настройки',
    admin: 'Админ',
  },

  guide: {
    title: 'Гид',
    subtitle: 'Всё, что нужно, чтобы освоить Astral Sticker Studio.',
    searchPlaceholder: 'Поиск по гиду…',
    noResults: 'Ничего не найдено.',
    start: {
      title: 'Начало работы',
      whatIsT: 'Что такое Astral?',
      whatIsD: 'Astral Sticker Studio превращает ваши изображения и видео в аккуратные стикерпаки Telegram — создание, публикация и обновление прямо в этом Mini App.',
      createT: 'Создать проект',
      createD: 'Нажмите «Создать пак», задайте название и выберите тип: изображения, видео или смешанный. Каждый проект — это один стикерпак Telegram.',
      uploadT: 'Добавить стикеры',
      uploadD: 'Загрузите один или сразу несколько файлов. Astral автоматически конвертирует каждый в нужный формат Telegram — без ручного изменения размера.',
    },
    stickers: {
      title: 'Стикеры',
      processT: 'Автоконвертация',
      processD: 'Изображения становятся прозрачными WebP 512×512, видео — короткими WebM, совместимыми с Telegram. Прозрачность сохраняется.',
      reorderT: 'Порядок',
      reorderD: 'Нажмите и удерживайте стикер, затем перетащите его. Порядок, который вы видите, использует и Telegram.',
      replaceT: 'Заменить или удалить',
      replaceD: 'Нажмите на стикер для предпросмотра, затем замените его медиа или удалите. В опубликованном паке изменения применятся при следующем обновлении.',
    },
    emoji: {
      title: 'Эмодзи',
      singleT: 'Один или несколько эмодзи',
      singleD: 'Каждому стикеру нужен хотя бы один эмодзи. Нажмите на стикер, чтобы изменить, или добавьте несколько (в пределах лимита Telegram) для лучшего поиска.',
      deviceT: 'Любой эмодзи устройства',
      deviceD: 'Используйте встроенный выбор или клавиатуру эмодзи вашего телефона — флаги, тона кожи, ZWJ и keycap-эмодзи работают.',
      presetsT: 'Наборы и последовательности',
      presetsD: 'Сохраняйте наборы эмодзи и применяйте повторяющуюся последовательность к нескольким стикерам в визуальном порядке — к выделению или всему паку.',
    },
    publish: {
      title: 'Публикация',
      linkT: 'Ссылка пака',
      linkD: 'Выберите префикс ссылки. Astral проверяет доступность вживую и всегда добавляет обязательный суффикс «_by_AstralStickerBot».',
      progressT: 'Прогресс публикации',
      progressD: 'Публикация идёт в фоне с реальным прогрессом. Для больших паков вы увидите загрузку стикеров по одному, затем экран успеха со ссылкой.',
      syncT: 'Обновить пак',
      syncD: 'Отредактируйте опубликованный проект и нажмите «Обновить пак Telegram», чтобы синхронизировать добавления, удаления, эмодзи и порядок — без дубликата. Новые паки под управлением Astral и с брендом ﹙@AstralStickerBot﹚.',
    },
    premium: {
      title: 'Премиум',
      freeT: 'Лимиты Free',
      freeD: 'На бесплатном плане — ограниченное число паков в месяц по типам. У владельца и админов лимитов нет.',
      howT: 'Как оформить',
      howD: 'Откройте Премиум, выберите срок, затем способ оплаты. Всё безопасно завершается в боте Astral.',
      methodsT: 'Томан или Stars',
      methodsD: 'Оплатите в томанах, отправив чек на проверку админом, или мгновенно через Telegram Stars — Stars активирует Премиум автоматически.',
    },
    more: {
      title: 'Ещё',
      channelsT: 'Каналы Astral',
      channelsD: 'Подборка официальных каналов Astral в Telegram. Нажмите, чтобы открыть. Добавлять и редактировать могут только админы — это необязательно и не влияет на ваши паки.',
      appearanceT: 'Язык и оформление',
      appearanceD: 'Переключайтесь между English, فارسی и Русским и выбирайте тему в Настройки → Оформление.',
      helpT: 'Нужна помощь?',
      helpD: 'Свяжитесь с командой Astral через официальный канал в разделе «Каналы Astral».',
    },
  },
  home: {
    greeting: 'Привет, {name}',
    heroKicker: 'Astral Studio',
    heroTitle: 'Sticker Studio',
    heroSubtitle: 'Создавайте красивые стикерпаки для Telegram.',
    createPack: 'Создать новый пак',
    createPackSub: 'Начните здесь',
    myProjects: 'Мои проекты',
    settings: 'Настройки',
    adminPanel: 'Панель админа',
    quickActions: 'Быстрые действия',
    recentProjects: 'Недавние проекты',
    viewAll: 'Показать все',
    noRecent: 'Пока нет проектов. Создайте свой первый пак!',
    toolsTitle: 'Инструменты Astral',
    tools: {
      projects: 'Проекты',
      projectsSub: 'Ваши стикерпаки',
      premium: 'Премиум',
      premiumSub: 'Больше возможностей',
      emojis: 'Эмодзи',
      emojisSub: 'Наборы эмодзи',
      channels: 'Каналы Astral',
      channelsSub: 'Официальные каналы',
      guide: 'Гид',
      guideSub: 'Освоить Astral',
      settings: 'Настройки',
      settingsSub: 'Язык и поддержка',
      admin: 'Админ',
      adminSub: 'Управление',
    },
    officialName: '@AstralAtelier',
    officialSub: 'Подпишитесь на нас в Telegram',
    introTitle: 'Добро пожаловать в Astral ✦',
    introBody: 'Ваша студия для создания стикерпаков Telegram.',
    introCta: 'Войти в студию',
  },
  projects: {
    title: 'Проекты',
    newProject: 'Новый проект',
    searchPlaceholder: 'Поиск проектов…',
    empty: 'Пока нет проектов',
    emptyHint: 'Создайте свой первый проект, чтобы начать.',
    emptySearch: 'Ничего не найдено по вашему запросу.',
    emptyArchived: 'Нет архивных проектов.',
    drafts: 'Черновики',
    all: 'Все',
    lastEdited: 'Изменён {date}',
    autosavedAt: 'Автосохранение {date}',
    open: 'Открыть',
    continueEditing: 'Продолжить',
    overview: 'Обзор',
    category: 'Категория',
    allCategories: 'Все категории',
    stickerCount: 'Стикеров: {count}',
    more: 'Ещё',
    archive: 'В архив',
    restore: 'Восстановить',
    deleteConfirmTitle: 'Удалить проект',
    deleteConfirmBody: 'Удалить «{title}»? Это действие необратимо.',
    archiveConfirmTitle: 'Архивировать проект',
    archiveConfirmBody: 'Отправить «{title}» в архив? Вы сможете восстановить его в любой момент.',
    restoreConfirmTitle: 'Восстановить проект',
    restoreConfirmBody: 'Вернуть «{title}» в активные проекты?',
    status: {
      DRAFT: 'Черновик',
      ACTIVE: 'Активный',
      ARCHIVED: 'В архиве',
    },
  },
  projectForm: {
    createTitle: 'Новый проект',
    editTitle: 'Изменить проект',
    titleLabel: 'Название',
    titlePlaceholder: 'Мой классный пак',
    descriptionLabel: 'Описание',
    descriptionPlaceholder: 'О чём этот пак?',
    statusLabel: 'Статус',
    categoryLabel: 'Категория',
    typeLabel: 'Тип стикеров',
    tagsLabel: 'Теги',
    tagsPlaceholder: 'Добавьте тег и нажмите Enter',
    notesLabel: 'Заметки',
    notesPlaceholder: 'Запишите идеи для этого пака…',
    create: 'Создать проект',
    save: 'Сохранить изменения',
    historyTitle: 'История версий',
    history: 'История',
    noHistory: 'Истории пока нет. Изменения сохраняются автоматически.',
    restore: 'Восстановить',
  },
  stickers: {
    failure: {
      unreadable: 'Не удалось прочитать это изображение.',
      tooLarge: 'Этот файл слишком большой.',
      tooDetailed: 'Изображение слишком детализировано для стикера.',
      temporary: 'Не удалось обработать изображение. Попробуйте ещё раз.',
      retrying: 'Временный сбой обработки. Повторяем…',
      cancelled: 'Загрузка отменена.',
    },
    title: 'Стикеры',
    count: 'Стикеров: {count}',
    add: 'Добавить стикер',
    empty: 'Пока нет стикеров',
    emptyHint: 'Добавьте первый стикер, чтобы собрать пак.',
    remove: 'Убрать стикер',
    removeConfirmTitle: 'Убрать стикер',
    removeConfirmBody: 'Убрать этот стикер из пака?',
    moveUp: 'Вверх',
    moveDown: 'Вниз',
    added: 'Стикер добавлен',
    removed: 'Стикер убран',
    replaced: 'Стикер заменён',
    addHint: 'Автоматически конвертируется в стикер Telegram.',
    processing: 'Обработка…',
    processFailed: 'Не удалось обработать файл.',
    limitReached: 'Достигнут лимит стикеров для этого пака.',
    errorReadFailed: 'Не удалось прочитать файл.',
    emoji: 'Эмодзи',
    changeEmoji: 'Изменить эмодзи',
    emojiListLabel: 'Эмодзи (1–20)',
    emojiUpdated: 'Эмодзи обновлён',
    replace: 'Заменить',
    preview: 'Предпросмотр',
    select: 'Выбрать',
    selectAll: 'Выбрать все',
    deselectAll: 'Снять выбор',
    range: 'Диапазон',
    rangeArmed: 'Коснитесь конца…',
    applyEmoji: 'Применить эмодзи',
    editEmoji: 'Изменить эмодзи',
    applySequence: 'Применить последовательность',
    selectedCount: 'Выбрано: {count}',
    bulkTitle: 'Эмодзи для {count}',
    bulkSame: 'Один',
    bulkSameDesc: 'Применить один эмодзи ко всем выбранным стикерам.',
    bulkSequence: 'Последовательность',
    bulkSequenceDesc: 'Повторять последовательность эмодзи по выбранным стикерам.',
    bulkPreset: 'Набор',
    bulkPresetDesc: 'Применить сохранённый набор к выбранным стикерам.',
  },
  emoji: {
    title: 'Выберите эмодзи',
    searchPlaceholder: 'Поиск эмодзи…',
    noResults: 'Эмодзи не найдены.',
    useKeyboard: 'Клавиатура устройства',
    customPlaceholder: 'Введите или вставьте любой эмодзи…',
    addEmoji: 'Добавить',
    invalid: 'Не эмодзи',
    categories: {
      recent: 'Недавние',
      smileys: 'Смайлы',
      gestures: 'Жесты',
      people: 'Люди',
      animals: 'Животные',
      food: 'Еда',
      activity: 'Активность',
      travel: 'Путешествия',
      objects: 'Объекты',
      hearts: 'Сердца',
      symbols: 'Символы',
      flags: 'Флаги',
    },
  },

  presets: {
    title: 'Наборы эмодзи',
    create: 'Новый набор',
    edit: 'Изменить',
    name: 'Название набора',
    namePlaceholder: 'напр. Мило',
    sequenceLabel: 'Последовательность эмодзи',
    empty: 'Пока нет наборов.',
    save: 'Сохранить набор',
    saveAs: 'Сохранить как набор',
    created: 'Набор создан',
    updated: 'Набор обновлён',
    deleted: 'Набор удалён',
    saveFailed: 'Не удалось сохранить набор.',
    apply: 'Применить',
    manage: 'Управление наборами',
    reorderHint: 'Удерживайте и тяните для порядка',
    add: 'Добавить эмодзи',
    defaultLabel: 'Эмодзи по умолчанию',
    singleDefault: 'Один по умолчанию',
    autoApply: 'Авто-применение к новым стикерам',
    applyToAll: 'Применить ко всем стикерам',
  },
  batch: {
    progress: '{done}/{total} обработано',
    added: 'Добавлено: {count}',
    failed: 'Ошибок: {count}',
    retry: 'Повторить ({count})',
    capacity: 'Добавлено {added} — достигнут лимит пака.',
  },
  stickerTypes: {
    IMAGE: 'Изображение',
    VIDEO: 'Видео',
    MIXED: 'Смешанный',
  },
  membership: {
    title: 'Сначала вступите в Astral ✦',
    body: 'Вступите в {channel}, чтобы пользоваться Sticker Studio.',
    join: 'Вступить в канал',
    checkAgain: 'Я вступил — Проверить снова',
    unavailable: 'Не удалось проверить подписку. Попробуйте ещё раз через момент.',
    required: 'Вступите в {channel}, чтобы создавать и публиковать паки.',
  },
  publish: {
    error: {
      syncInProgress: 'Этот пак уже обновляется. Подождите немного.',
      packFull: 'Пак заполнен. Telegram допускает до 120 стикеров — удалите несколько и обновите снова.',
      packMissing: 'Этого пака больше нет в Telegram.',
      stickerRejected: 'Telegram отклонил один из стикеров. Попробуйте заменить его.',
      mappingUnresolved: 'Не удалось сопоставить проект с его паком в Telegram, поэтому ничего не изменилось. Свяжитесь с поддержкой.',
      rateLimited: 'Telegram сейчас загружен. Повторите через момент — ваши изменения сохранены.',
      telegramUnavailable: 'Telegram временно недоступен. Попробуйте ещё раз.',
      mediaMissing: 'Не удалось прочитать файл одного из стикеров. Замените этот стикер.',
      unknown: 'При обновлении пака что-то пошло не так. Попробуйте ещё раз.',
    },
    action: 'Создать стикерпак',
    publishing: 'Создание пака…',
    successTitle: 'Пак создан',
    open: 'Открыть в Telegram',
    openPack: 'Открыть пак',
    copyLink: 'Копировать ссылку',
    needStickers: 'Сначала добавьте хотя бы один стикер.',
    failed: 'Не удалось создать пак.',
    published: 'Опубликован',
    count: 'Стикеров: {count}',
    update: 'Обновить пак',
    updating: 'Обновление…',
    synced: 'Синхронизировано',
    localChanges: 'Есть неопубликованные изменения',
    syncFailed: 'Ошибка синхронизации',
    syncDone: 'Пак обновлён',
    packMissing: 'Пак не найден в Telegram',
    reviewTitle: 'Проверка пака',
    reviewCta: 'Проверить и опубликовать',
    progressTitle: 'Публикация',
    ready: 'Стикерпак готов ✨',
    retry: 'Повторить',
    failedAt: 'Ошибка на этапе «{phase}»',
    phase: {
      PREPARING: 'Подготовка файлов',
      CREATING_SET: 'Создание набора',
      UPLOADING: 'Загрузка стикеров',
      FINALIZING: 'Завершение',
    },
  },

  packName: {
    action: 'Изменить название',
    title: 'Изменить название пака',
    nameLabel: 'Название пака',
    currentLabel: 'Текущее название в Telegram',
    newLabel: 'Новое название в Telegram',
    trimmed: 'Сокращено до 64 символов — ограничение Telegram.',
    hint: 'Название обновится в Telegram сразу. Ссылка на пак не меняется.',
    saved: 'Название пака обновлено',
    failed: 'Не удалось обновить название пака.',
  },
  packLink: {
    title: 'Ссылка на стикерпак',
    nameLabel: 'Название пака',
    branding: {
      label: 'Тег пака',
      none: 'Без тега',
      start: 'Тег в начале',
      end: 'Тег в конце',
    },
    linkLabel: 'Ссылка пака',
    linkPlaceholder: 'cute_cats',
    checking: 'Проверка доступности…',
    available: 'Доступно',
    taken: 'Уже занято',
    error: {
      empty: 'Введите ссылку',
      start: 'Должно начинаться с буквы',
      chars: 'Только латинские буквы, цифры и подчёркивания',
      underscore: 'Без повторяющихся или конечных подчёркиваний',
      tooLong: 'Слишком длинно',
    },
  },
  channels: {
    title: 'Каналы Astral',
    subtitle: 'Официальные каналы Astral.',
    empty: 'Пока нет каналов.',
    add: 'Добавить канал',
    addTitle: 'Добавить канал',
    editTitle: 'Изменить канал',
    usernameLabel: 'Юзернейм канала',
    usernamePlaceholder: '@channel',
    nameLabel: 'Название',
    labelLabel: 'Метка',
    descriptionLabel: 'Описание',
    descriptionPlaceholder: 'Краткое описание',
    categoryLabel: 'Категория',
    open: 'Открыть в Telegram',
    manage: 'Управление',
    removeConfirmTitle: 'Удалить канал',
    removeConfirmBody: 'Убрать {name} из Каналов Astral?',
  },
  usage: {
    title: 'Использование',
    plan: 'Тариф',
    free: 'Бесплатно',
    premium: 'Премиум',
    packs: '{used}/{limit} паков',
    unlimited: 'Безлимит',
    remaining: 'осталось {count}',
    limitTitle: 'Достигнут месячный лимит',
    limitBody: 'Вы использовали все бесплатные паки типа «{type}» в этом месяце.',
    upgrade: 'Перейти на Премиум',
    premiumSoon: 'Премиум скоро появится.',
  },
  categoryManager: {
    add: 'Добавить категорию',
    manage: 'Управление категориями',
    name: 'Название категории',
    create: 'Создать',
    delete: 'Удалить категорию',
    deleteConfirm: 'Удалить эту категорию?',
    deleteBody: 'Проекты из неё останутся, но будут без категории.',
    empty: 'Категорий пока нет.',
    none: 'Без категории',
    created: 'Категория добавлена',
    deleted: 'Категория удалена',
    errorRequired: 'Введите название категории.',
    errorDuplicate: 'Такая категория уже есть.',
    errorReserved: 'Такая категория уже есть.',
    errorTooLong: 'Название слишком длинное.',
    errorFailed: 'Не удалось сохранить категорию.',
    legacy: 'Без категории',
  },
  categories: {
    characters: 'Персонажи',
    movies: 'Фильмы',
    shows: 'Сериалы',
    comics: 'Комиксы',
    games: 'Игры',
    memes: 'Мемы',
  },
  settings: {
    title: 'Настройки',
    appearance: 'Оформление',
    theme: 'Тема',
    colorTheme: 'Цветовая тема',
    themeMode: 'Режим темы',
    language: 'Язык',
    profile: 'Профиль',
    account: 'Аккаунт',
    notifications: 'Уведомления',
    notificationsDesc: 'Получать обновления о ваших проектах.',
    role: 'Роль',
    about: 'О приложении',
    version: 'Версия',
    themeModes: {
      dark: 'Тёмная',
      light: 'Светлая',
      auto: 'Авто',
      custom: 'Своя',
    },
  },
  admin: {
    title: 'Панель админа',
    subtitle: 'Управляйте командой и участниками.',
    tabUsers: 'Пользователи',
    tabAdmins: 'Админы',
    searchPlaceholder: 'Поиск пользователей…',
    makeAdmin: 'Назначить админом',
    removeAdmin: 'Снять с админа',
    you: 'Вы',
    noUsers: 'Пользователи не найдены.',
    memberSince: 'С нами с {date}',
    total: '{count} участников',
    details: 'О пользователе',
    telegramId: 'Telegram ID',
    viewProfile: 'Открыть профиль в Telegram',
    noProfile: 'Нет публичного юзернейма',
    premium: 'Премиум',
    grantPremium: 'Выдать Премиум',
    revokePremium: 'Отозвать Премиум',
    copyId: 'Копировать ID',
    premiumUntil: 'Премиум до {date}',
    filterAll: 'Все',
    filterAttention: 'Требуют внимания',
    filterPremium: 'Премиум',
    filterPayments: 'Платежи',
    filterAdmins: 'Админы',
    attentionReceipt: 'Чек на проверку',
    reviewTitle: 'Проверка платежей',
    reviewOpen: 'Открыть проверку',
    queueEmpty: 'Сейчас нечего проверять.',
    plan: 'План',
    price: 'Цена',
    requested: 'Запрошено',
    receipt: 'Чек',
    viewReceipt: 'Открыть чек',
    noReceipt: 'Чек ещё не отправлен',
    approve: 'Одобрить',
    reject: 'Отклонить',
    approveConfirm: 'Одобрить платёж и активировать Премиум?',
    rejectConfirm: 'Отклонить платёж? Премиум не будет активирован.',
    rejectReason: 'Причина (необязательно)',
    approved: 'Одобрено',
    rejected: 'Отклонено',
    stAWAITING_RECEIPT: 'Ожидает чек',
    stRECEIPT_SUBMITTED: 'На проверке',
    stAPPROVED: 'Одобрено',
    stREJECTED: 'Отклонено',
    stEXPIRED: 'Истекло',
    stCANCELLED: 'Отменено',
    stAWAITING_PAYMENT: 'Ожидает оплаты',
    stCOMPLETED: 'Завершено',
    stREFUNDED: 'Возвращено',
    stFAILED: 'Ошибка',
    actionDone: 'Готово',
    method: 'Способ',
    methodToman: 'Томан / Вручную',
    methodStars: 'Stars / Авто',
    starsAmount: '⭐ {amount}',
    chargeId: 'ID платежа',
    filterHistory: 'История',
  },
  roles: {
    OWNER: 'Владелец',
    ADMIN: 'Админ',
    USER: 'Пользователь',
  },
  toast: {
    created: 'Проект создан',
    archived: 'Проект в архиве',
    restored: 'Проект восстановлен',
    duplicated: 'Проект дублирован',
    deleted: 'Проект удалён',
  },
  auth: {
    signingIn: 'Выполняется вход…',
    notInTelegram: 'Открыть в Telegram',
    notInTelegramHint: 'Это приложение работает внутри Telegram. Откройте его через бота.',
    failed: 'Не удалось войти',
    retry: 'Повторить',
  },
  errors: {
    generic: 'Что-то пошло не так.',
    network: 'Ошибка сети. Проверьте подключение.',
    unauthorized: 'Сессия истекла. Войдите снова.',
    notFound: 'Не найдено.',
    loadFailed: 'Не удалось загрузить. Попробуйте снова.',
  },

  premium: {
    title: 'Astral Премиум',
    active: 'Активен',
    free: 'Бесплатный план',
    statusFree: 'У вас бесплатный план',
    statusActive: 'Astral Премиум активен',
    expires: 'Истекает {date}',
    daysLeft: 'Осталось дней: {count}',
    homeTitle: 'Astral Премиум',
    homeBody: 'Больше паков и выше лимиты.',
    view: 'Открыть Премиум',
    renew: 'Продлить',
    upgradeHint: 'С Astral Премиум вы сможете создавать больше паков и использовать более высокие лимиты.',
    unlimitedPacks: 'Безлимитные паки в месяц',
    maxCapacityShort: 'Макс. ёмкость',
    tagIncluded: 'Метка Astral: ﹙@AstralStickerBot﹚',
    tagNone: 'Без метки Astral',
    starsUnit: 'Stars',
    perPackTotal: 'всего {count} / пак',
    mixedNote: 'изображения + видео вместе',
    compareTitle: 'Что вы получаете',
    planFree: 'Бесплатно',
    planMonth1: '1 месяц',
    planMonth3: '3 месяца',
    perPack: '{count} / пак',
    maxCapacity: 'Максимальная поддерживаемая ёмкость',
    subscribe: 'Оформить · {price}',
    tomanAmount: '{amount} туманов',
    imagePacks: 'Пакеты изображений',
    videoPacks: 'Видео-пакеты',
    mixedPacks: 'Смешанные пакеты',
    capacity: 'Стикеров в паке',
    plansTitle: 'Выберите план',
    bestValue: 'Выгоднее всего',
    save: 'Скидка {percent}%',
    month1: '1 месяц',
    month3: '3 месяца',
    month12: '12 месяцев',
    perksTitle: 'Что открывает Премиум',
    perkPacks: 'Безлимитные стикерпаки каждый месяц',
    perkStickers: 'До 120 стикеров в паке, для всех типов',
    freeLimitsTitle: 'Ваши бесплатные лимиты',
    premiumLimitsTitle: 'С Премиумом',
    unlimited: 'Безлимит',
    packsPerMonth: '{count} паков / мес',
    continueInBot: 'Продолжить в Telegram',
    purchaseNote: 'Покупка безопасно завершается в боте Astral.',
    methodTitle: 'Способ оплаты',
    methodToman: 'Оплата в Томанах',
    methodTomanSub: 'Вручную · проверка чека',
    methodStars: 'Telegram Stars',
    methodStarsSub: 'Мгновенно · автоактивация',
    toman: 'Томан',
    payStars: 'Оплатить ⭐ {amount}',
    continueStars: 'Перейти к оплате Stars',
    selectPlan: 'Выберите план',
    pendingTitle: 'Платёж на проверке',
    pendingBody: 'Ваш чек проверяется. Премиум активируется после одобрения.',
    awaitingTitle: 'Завершите в боте',
    awaitingBody: 'Откройте бот, чтобы отправить чек об оплате.',
    loadFailed: 'Не удалось загрузить информацию о Премиуме.',
  },

  premiumNotify: {
    receiptReceived: 'Чек получен ✅ Администратор Astral проверит его. Премиум активируется после одобрения.',
    approvedTitle: '✨ Astral Премиум активирован!',
    approvedBody: 'Ваш Премиум на {months} мес. активен. Истекает {date}.',
    openApp: 'Открыть Astral Studio',
    rejectedTitle: 'Чек не одобрен',
    rejectedBody: 'Ваш чек об оплате не был одобрен, поэтому Премиум не активирован.',
    rejectedReason: 'Причина: {reason}',
    tryAgain: 'Попробовать снова',
  },

  premiumBot: {
    intro: '✨ Astral Премиум открывает безлимитные стикерпаки и повышенные лимиты. Выберите план:',
    chosen: 'Astral Премиум — {plan}',
    chooseMethod: 'Выберите способ оплаты:',
    methodToman: 'Томан · {amount}',
    methodStars: 'Telegram Stars · ⭐ {amount}',
    toman: 'Томан',
    invoiceTitle: 'Astral Премиум — {plan}',
    invoiceDesc: 'Подписка Astral Премиум ({plan}). Мгновенная автоматическая активация.',
    invoiceFailed: 'Не удалось начать оплату Stars. Попробуйте снова: /premium.',
    planPick: 'Astral Премиум — {plan} за {price} {currency}.',
    windowNote:
      'Когда будете готовы оплатить, нажмите кнопку ниже. После начала платёжной сессии у вас будет {minutes} минут на отправку чека. Если время истечёт — просто начните новый запрос.',
    ready: 'Я готов оплатить',
    back: 'Назад',
    plansAgain: 'Показать планы',
    sessionTitle: '💳 Платёжная сессия начата — {plan} ({price} {currency})',
    paymentTitle: 'Реквизиты для оплаты:',
    cardNumber: 'Номер карты: {value}',
    cardHolder: 'Получатель: {value}',
    bankName: 'Банк: {value}',
    tomanUnavailable:
      'Оплата картой временно недоступна. Вы можете заплатить через Telegram Stars или попробовать позже.',
    expiresAt: 'У вас есть {minutes} минут, чтобы оплатить и отправить чек.',
    submit: 'Отправить чек',
    cancel: 'Отмена',
    sendReceipt: 'Пожалуйста, отправьте чек об оплате как фото или изображение/PDF-документ.',
    receiptConfirmed: 'Чек получен ✅ Администратор скоро проверит его. Премиум активируется после одобрения.',
    cancelled: 'Запрос на оплату отменён. Вы можете начать снова в любой момент: /premium.',
    expired: 'Эта платёжная сессия истекла. Начните новую: /premium.',
    noActive: 'У вас нет активной платёжной сессии. Начните её: /premium.',
    notImage: 'Пожалуйста, отправьте чек как фото или изображение/PDF-документ.',
    open: 'Открыть Astral Studio',
  },
  bot: {
    welcomeTitle: '✦ Astral Studio',
    welcomeBody: 'Добро пожаловать в Sticker Studio — превращайте фото и видео в стикерпаки Telegram.',
    startHint: 'Чтобы начать, нажмите «Open App».',
    chooseLanguage: 'Выберите язык бота',
    menuButton: 'Открыть приложение',
    premiumInfo:
      '✦ Astral Премиум\n\n' +
      'Выберите план и способ оплаты в Mini App.\n' +
      'Чтобы завершить оплату, вы вернётесь в этого бота:\n\n' +
      '⭐ Stars — оплата прямо в боте\n' +
      '💳 Томан — реквизиты карты и отправка чека в боте\n\n' +
      'Откройте Mini App и перейдите в раздел «Премиум».',
    help: {
      title: '✦ Astral Sticker Studio — Помощь',
      botTitle: '🤖 В этом боте',
      botBody:
        '/start — выбрать язык и открыть приложение\n' +
        '/premium — как работает Astral Премиум\n' +
        '/help — эта справка\n' +
        'Кнопка меню рядом с полем ввода открывает Sticker Studio.',
      payTitle: '⭐ Оплата проходит здесь, в боте',
      payBody:
        'Выберите план в Mini App, затем вернитесь сюда:\n' +
        '• Stars — оплатите счёт, который пришлёт бот\n' +
        '• Томан — бот пришлёт реквизиты карты; отправьте чек в ответ фотографией',
      appTitle: '✨ В Mini App',
      appBody:
        '• Новый пак — выберите «Изображение», «Видео» или «Смешанный»\n' +
        '• Проекты — все ваши паки, с поиском и фильтрами\n' +
        '• Добавить стикеры — загрузите фото или видео; они конвертируются автоматически\n' +
        '• Порядок — нажмите и удерживайте стикер, затем перетащите\n' +
        '• Эмодзи — нажмите на стикер, чтобы задать эмодзи, или измените сразу несколько через «Выбрать»\n' +
        '• Публикация — выберите ссылку пака (t.me/addstickers/…) и создайте пак\n' +
        '• Изменить название — переименуйте опубликованный пак в любой момент\n' +
        '• Тег пака — Премиум, Админ и Владелец могут перемещать или убирать тег ﹙@AstralStickerBot﹚\n' +
        '• Обновить пак — после правок отправьте изменения в Telegram\n' +
        '• Премиум, Настройки, Каналы Astral и Гид — на главном экране',
      staffTitle: '🛡 Для админов',
      staffBody: 'Откройте «Админ» на главном экране, чтобы проверять чеки Премиума и управлять пользователями.',
      channel: '📣 @AstralAtelier — новости и новые паки',
    },
  },
};
